import { Component } from "@opten/compiler/metadata/component";
import { addClass } from "@opten/dom/add-class";
import { hasClass } from "@opten/dom/has-class";
import { EventDispatcher } from "@opten/events/event-dispatcher";

import barba from "@barba/core";
import barbaCss from "@barba/css";

declare const Cookiebot: any;

@Component({ className: "js-page-transition" })
export class PageTransitionComponent {
	static onPageChange = new EventDispatcher<HTMLElement>();

	// tslint:disable-next-line: max-func-body-length
	constructor(private element: HTMLElement) {
		// const _listeners = [];

		// window.EventTarget || (window.EventTarget = function () {});
		// EventTarget.prototype.addEventListenerBase =
		// 	EventTarget.prototype.addEventListener;
		// EventTarget.prototype.addEventListener = function (
		// 	type,
		// 	listener,
		// 	options?
		// ) {
		// 	_listeners.push({
		// 		target: this,
		// 		type: type,
		// 		listener: listener,
		// 		options: options,
		// 	});
		// 	if (this) {
		// 		this.addEventListenerBase(type, listener, options);
		// 	}
		// };

		// EventTarget.prototype.removeEventListeners = function (targetTypes) {
		// 	for (let index = 0; index != _listeners.length; index++) {
		// 		const item = _listeners[index];

		// 		const target = item.target;
		// 		const type = item.type;
		// 		const listener = item.listener;

		// 		if (
		// 			target == this &&
		// 			(Array.isArray(targetTypes)
		// 				? targetTypes.includes(type)
		// 				: type == targetTypes)
		// 		) {
		// 			this.removeEventListener(type, listener);
		// 		}
		// 	}
		// };

		if (hasClass(this.element, "barba--init") === false) {
			barba.hooks.afterOnce(() => {
				addClass(this.element, "barba--init");
			});
			barba.hooks.after((e) => {
				if (!e) {
					return;
				}
				PageTransitionComponent.onPageChange.dispatch(e.next.container);
				return this.runScriptsInContainer(e.next.container).then(() => {
					if ("Cookiebot" in window) {
						Cookiebot.runScripts();
					}
					document.dispatchEvent(
						new Event("umbracoFormsReinitialize"),
					);
				});
			});
			barba.hooks.enter((data) => {
				if (!data) {
					return;
				}
				const startAt = data.next.container.querySelector(
					".js-page-transition-start-at",
				) as HTMLElement;
				if (startAt) {
					const pos = startAt.style.position;
					startAt.style.position = "relative";
					const offset = startAt.offsetTop;
					startAt.style.position = pos;
					if (window.scrollY > offset) {
						window.scrollTo(0, offset);
					}
				} else {
					window.scrollTo(0, 0);
				}
			});
			// barba.hooks.beforeLeave(() => {
			// 	window.removeEventListeners(['resize', 'scroll']);
			// 	document.removeEventListeners(['resize', 'scroll']);
			// });
			barba.hooks.leave((data) => {
				return new Promise((resolve) => {
					if (!data) {
						resolve();
						return;
					}
					if (
						data.current.namespace === "page" &&
						data.next.namespace === "page"
					) {
						resolve();
					}
					setTimeout(() => {
						resolve();
					}, 350);
				});
			});
			barba.use(barbaCss);
			barba.init({
				timeout: 10000,
				prevent: ({ el }) =>
					!!el.closest(".js-page-transition-prevent") ||
					!el.closest(".js-page-transition-start-at"),
				transitions: [
					{
						name: "slide-in",
						to: {
							namespace: ["page-slide"],
						},
						enter() {},
					},
					{
						name: "slide-out",
						from: {
							namespace: ["page-slide"],
						},
						to: {
							namespace: ["page"],
						},
						enter() {},
					},
					{
						name: "fade",
						from: {
							namespace: ["page"],
						},
						to: {
							namespace: ["page"],
						},
						enter() {},
					},
				],
				requestError: (trigger, action, url, response) => {
					// redirect to failed url (to show 404, 500 or just clean reload if timeout happend)
					return true;
				},
			});
		}
	}

	private runScriptsInContainer(container: HTMLElement): Promise<void> {
		const allScripts = Array.from(container.querySelectorAll("script"));
		if (allScripts.length === 0) {
			return Promise.resolve();
		}

		const immediateScripts: HTMLScriptElement[] = [];
		const deferredScripts: HTMLScriptElement[] = [];

		for (const script of allScripts) {
			if (script.hasAttribute("defer")) {
				deferredScripts.push(script);
			} else {
				immediateScripts.push(script);
			}
		}

		return [...immediateScripts, ...deferredScripts].reduce(
			(chain, script) => chain.then(() => this.executeScript(script)),
			Promise.resolve(),
		);
	}

	private executeScript(oldScript: HTMLScriptElement): Promise<void> {
		const newScript = document.createElement("script");

		for (const attribute of Array.from(oldScript.attributes)) {
			if (attribute.name === "defer") {
				continue;
			}

			if (
				attribute.name === "type" &&
				attribute.value.toLowerCase() === "text/plain"
			) {
				newScript.setAttribute("type", "application/javascript");
				continue;
			}

			newScript.setAttribute(attribute.name, attribute.value);
		}

		if (oldScript.src) {
			newScript.async = false;
		}

		const content = oldScript.textContent;
		if (content) {
			newScript.textContent = content;
		}

		return new Promise<void>((resolve) => {
			let settled = false;
			const done = () => {
				if (settled) {
					return;
				}
				settled = true;
				resolve();
			};

			newScript.onload = done;
			newScript.onerror = done;
			oldScript.parentNode?.replaceChild(newScript, oldScript);

			if (!oldScript.src) {
				done();
			}
		});
	}
}
